export enum WalletType {
    APPLE_PAY = "APPLE_PAY"
}
